/**
 * Add Product to Recently Viewed Action
 * Triggered by: arc:action:recentlyViewedAdd
 */

import shopifyHelper from "@js/utils/shopify";

const COOKIE_NAME = 'arc_recently_viewed';
const COOKIE_DAYS = 30;
const MAX_PRODUCTS = 20;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export const runRecentlyViewedAdd = async (data = {}) => {
    try {
        const { productId } = data;

        if (!productId) {
            throw new Error('Product ID is required');
        }

        const existingIds = JSON.parse(getCookie(COOKIE_NAME) || '[]').map(id => String(id).replace('gid://shopify/Product/', ''));
        const normalizedId = String(productId).replace('gid://shopify/Product/', '');
        const isDuplicate = existingIds.some(id => id === normalizedId);

        if (!isDuplicate) {
            const updatedIds = [normalizedId, ...existingIds].slice(0, MAX_PRODUCTS);
            setCookie(COOKIE_NAME, JSON.stringify(updatedIds), COOKIE_DAYS);

            const fetchedProducts = await shopifyHelper.getShopifyProductList([productId]);

            if (fetchedProducts && fetchedProducts.length > 0) {
                const addedProduct = fetchedProducts[0];

                window.dispatchEvent(new CustomEvent('recentlyViewed:updated', {
                    detail: {
                        products: updatedIds,
                        addedProduct
                    }
                }));

                return {
                    success: true,
                    products: updatedIds,
                    addedProduct,
                    message: 'Product added to recently viewed'
                };
            } else {
                throw new Error('Failed to fetch product data');
            }
        } else {
            return {
                success: true,
                products: existingIds,
                message: 'Product already in recently viewed list'
            };
        }

    } catch (error) {
        console.error('Recently Viewed Add error:', error);

        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'add'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

export default runRecentlyViewedAdd;
